// v5.8.3
// import Swiper from 'swiper';
// import 'swiper/css/swiper.min.css';


// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
// import "@fortawesome/fontawesome-free/css/all.css"
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import 'lodash';
import {enter, leave, toggle} from './js/lib/el-transition.js';
require('sharer.js');
window.tippy = tippy;
window.Swiper = Swiper;
window.flatpickr = flatpickr;
window.el = {
	enter:enter,
	leave:leave,
	toggle:toggle
}
window.moment = require('moment');


